import React from 'react';
import { apiPost, getHostApi } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { ENTITY_STATE, PORTFOLIO_TYPES, SUBJECT_TYPE } from '../monitoringConstants';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { popupActions } from '../../../store/popupStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { writeErr } from '../../common/logger';
import BbPopover from "../../common/popover";
import classnames from 'classnames';
import CsvExportButton from '../../common/csvExportButton';
import ExcelExportButton from '../../common/excelExportButton';
import Message from "../../common/message";
import moment from 'moment';
import Paging from '../../../components/common/pagingComponent';
import PortfolioSubjectHeader, { COLUMNS, SORT_TYPES } from './portfolioSubjectHeader';
import PortfolioSubjectRow from './portfolioSubjectRow';
import SearchIcon from '../../../img/icons/Search';
import SearchTip from '../../common/searchTip';
import Widget from '../../common/widget';

const COPY = "COPY";
const MOVE = "MOVE";

class PortfolioSubjectsSection extends React.Component {
    mounted = false;

    static defaultProps = {
        isFirstLevel: false
    };

    state = {
        pageSize: 20,
        page: 1,
        subjects: [],
        subjectsLoading: false,
        isPerson: null,
        isCompany: null,
        isDocument: null,
        hasAllFirstLevelPortfolios: null,
        selected: [],
        sortByColumn: null,
        sortType: SORT_TYPES.asc,
        fulltext: "",
        isA2A: false,
        isActionInProgress: false // pridane pre zabranenie double clicku
    };

    render() {
        return (
            <Widget className="create-portfolio-widget" header="Monitoring.Create.Subjects" initialExpanded={true}>
                <div style={{ paddingBottom: "0.5em" }}>
                    {this.props.subjectMessageType && <div className="w-100">
                        <Message type={this.props.subjectMessageType} message={this.props.subjectMessageText} options={{ renderInnerHtml: true }} shadowed style={{ marginBottom: '0.5em' }} />
                    </div>}
                    <div className="monitoring-search-portfolio">
                        <div className="search-container">
                            <div className="search-inputs">
                                <div className="control-row">
                                    <div className="control">
                                        <div className="search">
                                            <span className='with-pointer'>
                                                <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='0 0 200 200' />
                                            </span>
                                            <input
                                                onKeyDown={this.searchInPortfolioSubmit} value={this.state.fulltext}
                                                onChange={(e) => this.setState({ fulltext: e.target.value })}
                                                placeholder={this.props.translate("Monitoring.Search.InPorfolio")} type="text" className='ellipsis search-input' />
                                        </div>
                                        <div className='search-progress' />
                                    </div>
                                </div>
                            </div>
                            <button type="button" className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.searchInPortfolioSubmit}>
                                <Translate id="Search.Common.Search" />
                            </button>
                            <SearchTip windowId={`tips_portfolio_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)}
                                className="hide-on-mobile" style={{ textAlign: 'left', marginBottom: '0', marginTop: '1em', fontSize: '.875em' }} />
                        </div>
                        <div className="export-buttons-container">
                            {this.props.subjectsCount > 0 &&
                                <BbPopover
                                    content={this.props.translate('Portfolio.Export.TooMuchData')}
                                    placement="top"
                                    targetId='btnCsvExport'
                                    toggleOnEvent={this.props.subjectsCount > this.props.subjectsExportCsvMax ? "toggleOnMouse" : "toggleNever"}>
                                    <div id='btnCsvExport'>
                                        <CsvExportButton portfolioId={this.props.subjects[0].portfolioId} report="PortfolioSubjectsCsv" asButton offlineExport disabled={this.props.subjectsCount > this.props.subjectsExportCsvMax} />
                                    </div>
                                </BbPopover>
                            }
                            {this.props.subjectsCount > 0 &&
                                <BbPopover
                                    content={this.props.translate('Portfolio.Export.TooMuchDataAnother')}
                                    placement="top"
                                    targetId='btnExcelExport'
                                    toggleOnEvent={this.props.subjectsCount > this.props.subjectsExportExcelMax ? "toggleOnMouse" : "toggleNever"}                                >
                                    <div id='btnExcelExport'>
                                        <ExcelExportButton portfolio={this.props.subjects[0].portfolioId} report="subjects" offlineExport asButton disabled={this.props.subjectsCount > this.props.subjectsExportExcelMax} />
                                    </div>
                                </BbPopover>
                            }
                            {this.props.isFirstLevel || this.props.sharingRole > 2 ? null : <div>
                                <button type="button"
                                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    onClick={() => this.openSearchPopup()}
                                >
                                    <Translate id="Portfolio.Add.Subject"></Translate>
                                </button>
                            </div>}
                        </div>
                    </div>
                </div>
                {this.showSubjectsGrid()}
            </Widget>
        );
    }

    refresh = () => {
        this.props.refresh();
    }

    componentDidMount() {
        this.mounted = true;
        // bind subjects when editing portfolios
        this.setState({
            subjects: this.props.subjects.map(s => ({ ...s, checked: false, state: ENTITY_STATE.loaded })),
            isPerson: this.props.pt === PORTFOLIO_TYPES.personCz || this.props.pt === PORTFOLIO_TYPES.personSk,
            isCompany: this.props.pt === PORTFOLIO_TYPES.companyCz || this.props.pt === PORTFOLIO_TYPES.companySk,
            isDocument: this.props.pt === PORTFOLIO_TYPES.cadastreSk,
            hasAllFirstLevelPortfolios: this.props.hasAllFirstLevelPortfolios,
            isA2A: this.props.isA2A
        }, () => { /*console.log("STATE", this.state)*/ });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    getSearchTipsModel() {
        if (this.state.isPerson) {
            if (this.props.isFirstLevel) {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.PersonStLevel.Body') };
            }
            else {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.Person.Body') };
            }
        }
        if (this.state.isCompany) {
            if (this.props.isFirstLevel) {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.CompanyStLevel.Body') };
            }
            else {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.Company.Body') };
            }
        }
        if (this.state.isDocument) {
            if (this.props.isFirstLevel) {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.DocumentStLevel.Body') };
            }
            else {
                return { title: `${this.props.translate('Monitoring.Overview.Monitoring')}`, bodyHtml: this.props.translate('SearchTips.Monitoring.Document.Body') };
            }
        }
    }

    setDefaultSortingColumn(pt, isFirstLevel) {
        if (pt === PORTFOLIO_TYPES.personCz || pt === PORTFOLIO_TYPES.personSk || pt === PORTFOLIO_TYPES.companyCz || pt === PORTFOLIO_TYPES.companySk) {
            return isFirstLevel ? COLUMNS.fullName : COLUMNS.name;
        } else if (pt === PORTFOLIO_TYPES.cadastreSk) {
            return COLUMNS.ownershipDocumentNumber;
        }
        return null;
    }

    openSearchPopup = () => {
        this.props.showPopup("searchSubjectPopup",
            {
                open: true,
                close: (clearMessage) => {
                    if (clearMessage)
                        this.props.changeMessage(null, null);
                    this.props.hidePopup();
                },
                formik: this.props.formik,
                refresh: () => { this.refresh(); },
                changeMessage: (type, text) => this.props.changeMessage(type, text)
            }
        )
    }

    searchInPortfolioSubmit = event => {
        if (isNullOrUndefined(event) || (event.type === 'keydown' && event.key !== 'Enter')) {
            return;
        }

        this.getSubjects(this.state.page, this.state.sortByColumn, this.state.sortType, this.state.fulltext);
    }

    openMovePopup = (ids, mode) => {
        if (this.state.isActionInProgress) return;
        this.setState({ isActionInProgress: true });
        this.props.showPopup("moveSubjectPopup",
            {
                open: true,
                close: (clearMessage) => {
                    if (clearMessage)
                        this.props.changeMessage(null, null);
                    this.props.hidePopup();
                    if (this.mounted) this.setState({ isActionInProgress: false });
                },
                ids: ids,
                portfolioId: this.getPortfolioId(),
                portfolioType: parseInt(this.props.formik.values.identification.portfolioType),
                mode: mode,
                refresh: () => this.refresh(),
                changeMessage: (type, text) => this.props.changeMessage(type, text)
            }
        )
    }

    showSubjectsGrid = () => {
        const subjectType = this.getSubjectType();

        if (this.props.isFirstLevel)
            return this.renderFirstLevelSubjectsGrid(subjectType);

        return (
            <div className="columns is-centered" style={{ flexDirection: "column", margin: 0 }}>
                <table style={{ fontSize: "0.8em" }}
                    className={classnames('table table-report-section fixed subjects-table with-ellipsed-column', { 'blurred': this.state.subjectsLoading })}
                >
                    <thead className="portfolio-subject-header">
                        <PortfolioSubjectHeader
                            subjectType={subjectType}
                            onCheckAllClicked={this.onAllClick}
                            checkAllValue={this.state.subjects.every(s => s.checked === true) ? true : this.state.subjects.every(s => !s.checked) ? false : null}
                            sortBy={this.state.sortByColumn}
                            sortType={this.state.sortType}
                            onSortByColumn={this.sortSubjects}
                        />
                    </thead>
                    <tbody>
                        {this.state.subjects.map((s, i) => <PortfolioSubjectRow
                            key={s.id}
                            index={i}
                            subject={s}
                            subjectType={subjectType}
                            onCheckedChanged={this.updateProperty}
                            onMoveClicked={this.openMovePopup}
                            onCopyClicked={this.openMovePopup}
                            onApplyClicked={this.updateLabel}
                            onRemoveClicked={this.removeSubject}
                            sharingRole={this.props.sharingRole}
                        />)}
                    </tbody>
                </table>
                {this.renderBulkActions()}
                {this.renderPaging()}
            </div>
        );
    }

    renderFirstLevelSubjectsGrid = (subjectType) => {
        return (
            <div className="columns is-centered" style={{ flexDirection: "column", margin: 0 }}>
                <table style={{ fontSize: "0.8em" }}
                    className={classnames('table table-report-section fixed subjects-table with-ellipsed-column', { 'blurred': this.state.subjectsLoading })}
                >
                    <thead className="portfolio-subject-header">
                        <PortfolioSubjectHeader
                            subjectType={subjectType}
                            sortBy={this.state.sortByColumn}
                            sortType={this.state.sortType}
                            onSortByColumn={this.sortSubjects}
                            isFirstLevel />
                    </thead>
                    <tbody>
                        {this.state.subjects.map((s, i) => <PortfolioSubjectRow subjectType={subjectType} subject={s} index={i} isFirstLevel />)}
                    </tbody>
                </table>
                {this.renderPaging()}
            </div>
        );
    }

    renderBulkActions = () => {
        const { subjects, selected, isFirstLevel, isActionInProgress } = this.state;
        return (
            <div className="monitoring-subjects-actions">
                {this.props.sharingRole <= 3 && <a className={classnames('link-internal', { 'disabled': subjects.length === 0 || selected.length === 0 || isActionInProgress })} onClick={() => this.openMovePopup(selected, COPY)}>
                    <Translate id="Monitoring.Create.CopySelected" />
                </a>}
                {this.props.sharingRole < 3 && <a className={classnames('link-internal', { 'disabled': subjects.length === 0 || selected.length === 0 || isActionInProgress })} onClick={() => this.openMovePopup(selected, MOVE)}>
                    <Translate id="Monitoring.Create.MoveSelected" />
                </a>}
                {this.props.sharingRole < 3 && <a className={classnames('link-internal', { 'disabled': subjects.length === 0 || selected.length === 0 || isActionInProgress })} onClick={() => this.bulkRemove(selected)}>
                    <Translate id="Monitoring.Create.DeleteSelected" />
                </a>}
                {(this.props.sharingRole < 3 && !isFirstLevel) && <a className={classnames('link-internal', { 'disabled': subjects.length === 0 || isActionInProgress })} onClick={() => this.allRemove()}>
                    <Translate id="Monitoring.Create.DeleteAll" />
                </a>}
            </div>
        );
    }

    renderPaging = () => {
        return (this.state.page && Math.ceil(this.props.subjectsCount / this.state.pageSize) > 1) ? (
            <div className='column is-centered paging-root'>
                <Paging selectedPage={this.state.page}
                    totalPages={Math.ceil(this.props.subjectsCount / this.state.pageSize)}
                    setPage={page => {
                        this.setState({ page: page });
                        this.getSubjects(page, this.state.sortByColumn, this.state.sortType, this.state.fulltext);
                    }} />
            </div>
        ) : null;
    }

    renderWarning = (w) => {
        return (
            <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: "wrap" }}>
                {w.map((x, i) => <span title={x.description} key={i} className={`r-padded rel-warn rel-warn-status-${x.statusId}`}>
                    {x.shortening}
                </span>)}
            </div>
        );
    }

    updateProperty = (id, prop, value) => {
        var selected = this.state.selected;
        if (value)
            selected.push(id);
        else
            selected = selected.filter(f => { return f !== id });

        this.setState({
            selected: selected,
            subjects: this.state.subjects.map(s =>
                (s.id === id ? { ...s, [prop]: value, state: prop !== "checked" ? ENTITY_STATE.edited : s.state } : s))
        });
    }

    removeSubject = (id) => this.bulkRemove([id]);

    getPortfolioId = () => parseInt(window.location.pathname.match(/\d+/)[0]);

    onAllClick = (value) => {
        var selected = this.state.selected;
        this.state.subjects.forEach(s => {
            if (value) {
                if (selected.indexOf(s.id) === -1)
                    selected.push(s.id);
            }
            else
                selected = selected.filter(f => { return f !== s.id });
        });

        let copy = [...this.state.subjects];
        copy.forEach(x => x.checked = value);
        this.setState({ subjects: copy, selected: selected });
    }

    getSubjectType = () => {
        if (this.state.isPerson)
            return SUBJECT_TYPE.person;
        if (this.state.isCompany)
            return SUBJECT_TYPE.company;
        if (this.state.isDocument)
            return SUBJECT_TYPE.document;
        return SUBJECT_TYPE.unknown;
    }

    bulkRemove(toRemove) {
        if (this.state.isActionInProgress) return;
        this.setState({ isActionInProgress: true });
        apiPost(`${getHostApi()}/api/portfolio/${this.getPortfolioId()}/subjects/remove`, null, toRemove,
            (s) => {
                if (s.data.isSuccess) {
                    this.props.refresh();
                    this.props.changeMessage("success", this.props.translate("Portfolio.Search.PortfolioUpdated"));
                } else {
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptionData(s.data.exceptionData)));
                }
                if (this.mounted) this.setState({ isActionInProgress: false });
            },
            (e) => {
                writeErr(e);
                this.props.changeMessage("error", e.data.error.message ? this.props.translate(e.data.error.message) : this.props.translate('Common.Error'));
                if (this.mounted) this.setState({ isActionInProgress: false });
            }
        );
    }

    allRemove() {
        if (this.state.isActionInProgress) return;
        this.setState({ isActionInProgress: true });
        apiPost(`${getHostApi()}/api/portfolio/${this.getPortfolioId()}/subjects/remove-all`, null, undefined,
            (s) => {
                if (s.data.isSuccess) {
                    this.props.refresh();
                    this.props.changeMessage("success", this.props.translate("Portfolio.Search.PortfolioUpdated"));
                } else {
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptionData(s.data.exceptionData)));
                }
                if (this.mounted) this.setState({ isActionInProgress: false });
            },
            (e) => {
                writeErr(e);
                this.props.changeMessage("error", e.data.error.message ? this.props.translate(e.data.error.message) : this.props.translate('Common.Error'));
                if (this.mounted) this.setState({ isActionInProgress: false });
            }
        );
    }

    sortSubjects = (column, type) => {
        if (column === 'Warnings')
            return;
        this.setState({ sortByColumn: column, sortType: type }, () => {
            this.getSubjects(this.state.page, this.state.sortByColumn, this.state.sortType, this.state.fulltext);
        });
    }

    getSubjects(page, sortByColumn, sortType, fullText) {
        let filter = { "page": page.toString(), "count": "20" };
        if (!isNullOrUndefined(sortByColumn) && !isNullOrUndefined(sortType)) {
            filter = { ...filter, "orderBy": sortByColumn, "orderType": sortType }
        }

        if (!isNullOrUndefined(fullText)) {
            filter = { ...filter, "fullText": this.tryParseDate(fullText) }
        }

        this.setState({ subjectsLoading: true });
        apiPost(`${getHostApi()}/api/portfolio/${this.getPortfolioId()}/subjects`, {}, filter,
            (s) => {
                if (s.data.isSuccess) {
                    s.data.subjects.forEach(f => { if (this.state.selected.indexOf(f.id) !== -1) f.checked = true });
                    this.setState({ subjects: s.data.subjects })
                } else
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptionData(s.data.exceptionData)));
            },
            (e) => writeErr(e),
            () => this.setState({ subjectsLoading: false })
        );
    }

    tryParseDate(fulltext) {
        var dateformatOut = "DD.MM.YYYY";

        if (moment(fulltext, ["MM/DD/YYYY", "M/D/YYYY"], true).isValid()) {
            return moment(fulltext, ["MM/DD/YYYY", "M/D/YYYY"]).format(dateformatOut);
        }
        if (moment(fulltext, ["DD.MM.YYYY", "D.M.YYYY"], true).isValid()) {
            return moment(fulltext, ["DD.MM.YYYY", "D.M.YYYY"]).format(dateformatOut);
        }
        return fulltext;
    }

    updateLabel = (subjectId, label) => {
        const subject = this.state.subjects.find(s => s.id === subjectId);
        if (!isNullOrUndefined(subject) && subject.label === label)
            return;

        apiPost(`${getHostApi()}/api/portfolio/${this.getPortfolioId()}/update-label`, {},
            { subjectId: subjectId, subjectType: this.getSubjectType(), label: label },
            (s) => {
                if (s.data.isSuccess)
                    this.props.refresh();
                else
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptionData(s.data.exceptionData)));
            },
            (e) => writeErr(e)
        );
    }

    getExceptionData = (e) => isNullOrUndefined(e) ? undefined : e;
}

export default connectFormik(
    withLocalize(
        connect(
            state => state.domain,
            dispatch => bindActionCreators({ ...popupActions }, dispatch),
        )(PortfolioSubjectsSection)
    )
);